import React, { useState } from "react";
import { Button } from "@material-tailwind/react";
import { UserPlusIcon } from "lucide-react";
import LeadFormModal from "../lead/leadFormModal";

const ReceptionistLead = () => {
	const [formModalOpen, setFormModalOpen] = useState(false);

	const openAddLeadModal = () => {
		setFormModalOpen(true);
	};

	return (
		<div>
			<div className="m-5 p-5 border rounded-3xl">
				<div className="flex flex-col items-center justify-center text-center py-16 gap-4">
					<div className="rounded-full bg-orange-50 p-6">
						<UserPlusIcon size={48} className="text-orange-900" />
					</div>
					<h1 className="text-2xl font-thin">Add a New Lead</h1>
					<p className="text-sm text-gray-600 max-w-md">
						Capture a new lead by filling out the form. Submitted leads are forwarded to the team for follow-up.
					</p>
					<Button
						onClick={openAddLeadModal}
						className="rounded-full flex items-center gap-2"
						color="orange"
					>
						<UserPlusIcon size={16} /> Add New Lead
					</Button>
				</div>

				<LeadFormModal
					isOpen={formModalOpen}
					onClose={() => setFormModalOpen(false)}
					leadId={null}
					isUpdating={false}
					onSuccess={() => { }}
					readOnly={false}
				/>
			</div>
		</div>
	);
};

export default ReceptionistLead;
